import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'

import { ONE_YEAR_IN_SECONDS } from '../constants'
import { TopbarUser } from '../types'

const MANAGE_USERS_ITEMS_SEEN_COOKIE = 'manage_users_items_seen'

export const isManageUsersItemsSeen = (user?: TopbarUser) => {
  const isB2BSelfService = user?.isB2BSelfService ?? false
  if (!isB2BSelfService) return true

  const hasAlreadySeenManageUsersItems = getCookie(null, MANAGE_USERS_ITEMS_SEEN_COOKIE) === 'true'

  return hasAlreadySeenManageUsersItems
}

export const handleSetManageUsersItemsSeen = () => {
  setJusbrasilCookie(null, MANAGE_USERS_ITEMS_SEEN_COOKIE, 'true', {
    maxAge: ONE_YEAR_IN_SECONDS,
  })
}
